import { render, staticRenderFns } from "./TermsOfUsePage.vue?vue&type=template&id=e9e511f0&scoped=true"
import script from "./TermsOfUsePage.vue?vue&type=script&lang=js"
export * from "./TermsOfUsePage.vue?vue&type=script&lang=js"
import style0 from "./TermsOfUsePage.vue?vue&type=style&index=0&id=e9e511f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e511f0",
  null
  
)

export default component.exports